<template>
	<div
		@click="handleClicks"
		class="html-content"
		role="textbox"
		v-if="html"
		ref="htmlContent"
		v-once
		v-html="html"
	></div>
</template>

<script>
export default {
	name: 'html-content',
	props: ['html'],
	computed: {},

	mounted() {
		// this.handleClicksJQ();
		//const VM = this;
		//let gformLoader = jQuery(document).find('.call-gf-form');
		//console.log(gformLoader)
		/* VM.$nextTick(()=>{
            const content = VM.$refs.htmlContent;
            if(content){
                let gravityForm = jQuery(content.$el).find('.call-gf-form');

                if(gravityForm.length > 0){
                    gravityForm.each( (i, form) => {
                        VM.loadGravityForm(form);
                    });
                }
            }
        }) */
	},
	methods: {
		handleClicks() {
			// console.log('click')
		},
	},
}
</script>
